import { useState } from "preact/hooks"
import { Modal, ModalWrapper } from "src/utils/fw"
import { useLocalStorage } from "src/utils/hooks"
import { useDayOfEvent, useTime } from "../utils"
import { Column, Row } from "./layout"
import { get } from "src/utils/http"
import { isMember } from "../utils"

const delay = async (ms = interval) => new Promise(res => setTimeout(res, ms))

export const IBMPopup = (currentPage) => {
	const day = useDayOfEvent()
	const {hours: hour} = useTime()
	const [lastDisplayed, updateLastDisplayed] = useLocalStorage("ibm-popup-displayed")
	const [isEmailAllowed, setEmailAllowed] = useState(false)
	const [isPhoneAllowed, setPhoneAllowed] = useState(false)
	const [email, setEmail] = useState("")
	const [phone, setPhone] = useState("")
	const [errorText, setErrorText] = useState("")

	const [isSubmitting, setSubmitting] = useState(false)

	const [{
		"Registrant ID": id,
	}] = window.dataLayer

	const close = () => {
		updateLastDisplayed({...lastDisplayed, [window.location.hash]: {time: new Date()}})
	}

	const submit = async () => {
		if (!(isEmailAllowed || isPhoneAllowed)) {
			setErrorText("Please accept either phone or email contacts if you are giving IBM permission to contact you. Otherwise, dismiss this dialog with the close button at the top-right corner.")
			return false
		}
		if (isEmailAllowed && email === "") {
			setErrorText("Please provide an email address")
			return false
		}
		if (isPhoneAllowed && phone === "") {
			setErrorText("Please provide a phone number")
			return false
		}
		setSubmitting(true)
		setTimeout(() => setErrorText("Looks like something went wrong, please refresh the page and try again."), 5000)
		try {
			const res = await get(`https://isf2021.swoogo-retrofit.tkevents.io/misc/ibmsignup`, {id, email, phone})
			if (res?.status >= 300) {
				throw {status: res.status}
			}
			await delay(500)
			close()
		} catch (e) {
			console.error(e)
			setErrorText("Looks like something went wrong, please refresh the page and try again.")
		}
	}

	const shouldDisplayUnlessRecentlyOpened = (
		(
			window.location.hash.includes("breakout-four")
			&& (
				(day === 1 && hour === 10)
				|| (day === 1 && hour === 19)
				|| (day === 2 && hour === 3)
				|| (new Date().getUTCDate() === 23 && new Date().getUTCHours() === 11)
			)
		)
		|| (
			window.location.hash.includes("exhibition-hall-platinum")
		)
		|| (
			window.location.hash.includes("sponsor-theatre")
			&& (day === 2 && hour === 16)
			|| (new Date().getUTCDate() === 23 && new Date().getUTCHours() === 11)
		)
	)

	const notRecentlyOpen = (
		lastDisplayed === null
		|| lastDisplayed[window.location.hash] === undefined
		|| new Date(lastDisplayed[window.location.hash]) < new Date() - 3600000
	) 

	if (shouldDisplayUnlessRecentlyOpened && notRecentlyOpen && isMember) {
		return <Modal dismiss={close}><ModalWrapper wrapperStyle={{padding: "40px"}}>
			<Column styleOverride={{maxWidth: "680px", width: "60vw", color: "white", alignItems: "stretch"}}>
				<img style={{margin: "0 auto", maxWidth: "100%", width: "400px"}} src="https://assets.swoogo.com/uploads/medium/1381940-6154b5d9aac71.jpeg" />
				<h4>IBM may use my contact data to keep me informed of products, services and offerings:</h4>
				<Row>
					<input
						style={{margin: 0, padding: 0}}
						type="checkbox"
						onclick={() => setEmailAllowed(!isEmailAllowed)}
						name="IBM Email allowed"
						checked={isEmailAllowed}
					/>
					<label style={{margin: "0 0 0 5px", padding: 0}} for="emailAllowed">By email</label>
				</Row>
				{
					isEmailAllowed &&
					<input
						style={{margin: "0 0 10px 0", padding: "3px", color: "black"}}
						type="text"
						name="emailAddress"
						placeholder="Email address"
						onChange={({target: {value}}) => setEmail(value)}
					/>
				}
				<Row>
					<input
						style={{margin: 0, padding: 0}}
						type="checkbox"
						onclick={() => setPhoneAllowed(!isPhoneAllowed)}
						name="IBM Phone allowed"
						checked={isPhoneAllowed}
					/>
					<label style={{margin: "0 0 0 5px", padding: 0}} for="phoneAllowed">By phone</label>
				</Row>
				{
					isPhoneAllowed &&
					<input
						style={{margin: 0, padding: "3px", color: "black"}}
						type="text"
						name="phoneNumber"
						placeholder="Phone number"
						onChange={({target: {value}}) => setPhone(value)}
					/>
				}
				<p style={{marginTop: "10px"}}>
					You can withdraw your marketing consent at any time
					by submitting <a target="_blank" href="https://www.ibm.com/account/reg/us-en/signup?formid=urx-42537">an opt-out request</a>. Also you may unsubscribe
					from receiving marketing emails by clicking the
					unsubscribe link in each email.
				</p>
				<p>
					More information on our processing can be found in the
					<a target="_blank" href="http://www.ibm.com/privacy/sg/en/">IBM Privacy Statement</a>. By submitting this form, I
					acknowledge that I have read and understand the IBM
					Privacy Statement.
				</p>
				<button
					style={{
						height: "48px",
						backgroundColor: "transparent",
						fontSize: "16px",
						color: "rgb(255, 255, 255)",
						overflow: "hidden",
						boxSizing: "border-box",
						justifyContent: "center",
						alignItems: "center",
						width: "100%",
						padding: "0 12px",
						outline: "none",
						whiteSpace: "nowrap",
						textOverflow: "ellipsis",
						fontWeight: "700",
						lineHeight: "1",
						border: "2px solid white",
						borderRadius: "6px",
					}}
					onClick={submit}
				>
					{isSubmitting ? "Submitting..." : "Submit"}
				</button>
				{errorText.length > 1 && <><hr /><p>{errorText}</p></>}
			</Column>
		</ModalWrapper></Modal>
	} else {
		return null
	}
}